import { useContext } from 'react';
import { List } from 'react-feather';
import { TableEmpty } from '@/components/presentation/Table.Empty';
import { ProjectClipsFiltersContext } from './context';

export const ClipsTableEmpty = () => {
  const filters = useContext(ProjectClipsFiltersContext);

  const copy = filters.keyword ? searchCopy : tagsCopy;

  return (
    <TableEmpty
      Icon={() => <List size={120} />}
      message={copy.message}
      note={copy.note} />
  );
};

ClipsTableEmpty.displayName = 'Project.Clips.Table.Empty';

const tagsCopy = {
  message: `No clips available.`,
  note: `Tag and highlight transcripts to view highlights from the interview.`,
};
const searchCopy = {
  message: `No results found.`,
  note: `Try updating filters or searching for a different keyword.`,
};